/**
 * 统计数据API服务
 */
import { request } from '@/api/client'
import { API_ENDPOINTS } from '@/api/endpoints'

const STATS_ENDPOINTS = API_ENDPOINTS.STATS

export const statsApi = {
  /**
   * 获取概览统计
   */
  getOverview() {
    return request.get(STATS_ENDPOINTS.OVERVIEW)
  },

  /**
   * 获取用户统计（活跃度等）
   */
  getUserStats() {
    return request.get(STATS_ENDPOINTS.ACTIVE_USERS)
  },

  /**
   * 获取内容统计
   */
  getContentStats() {
    return request.get(STATS_ENDPOINTS.CONTENT_STATS)
  },

  /**
   * 获取系统运行统计
   */
  getSystemStats() {
    return request.get(STATS_ENDPOINTS.SYSTEM_OVERVIEW)
  },

  /**
   * 获取趋势数据
   */
  getTrends(days: number = 7) {
    return request.get(STATS_ENDPOINTS.TRENDS, {
      params: { days }
    })
  },

  /**
   * 获取分布数据
   */
  getDistribution() {
    return request.get(STATS_ENDPOINTS.DISTRIBUTION)
  },

  /**
   * 获取实时数据
   */
  getRealtime() {
    return request.get(STATS_ENDPOINTS.REALTIME)
  }
}
